import { createGlobalStyle } from "styled-components";

import MontserratBoldWoff from "./Montserrat-Bold.woff";
import MontserratRegularWoff from "./Montserrat-Regular.woff";

export default createGlobalStyle`
    @font-face {
    font-family: 'Montserrat';
    src: url(${MontserratRegularWoff}) format('woff');
    font-weight: 100 500;
    font-style: normal;
    }

    @font-face {
    font-family: 'Montserrat';
    src: url(${MontserratBoldWoff}) format('woff');
    font-weight: 700 900;
    font-style: normal;
    }
`;
